import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import { H1 } from '../containers/Headers';
import Button from '../button/Button';
import { TranslatedCopy } from '../../intl';

const Alert = ({ title, content, cancelText, confirmText, cancelAction, confirmAction, disabled }) => (
  <div data-testid='modal_alert' className='alert ta-sm-c pt5-lg pb5-lg'>
    <H1 className='mb7-sm' data-desc='alert__title'>
      {title}
    </H1>
    <p className='body-4 mb4-sm mb10-md' data-desc='alert__content'>
      {content}
    </p>
    <div>
      <div className='ncss-row'>
        {cancelAction && (
          <div className='ncss-col-md-6 ncss-col-sm-12'>
            <Button
              type='button'
              secondary
              extraClassName='mt3-sm mt0-md ncss-btn-border-medium-grey'
              onClick={cancelAction}
              data-desc='alert__close'
              disabled={disabled}
            >
              {cancelText || <TranslatedCopy id='global.cancel' />}
            </Button>
          </div>
        )}
        <div className={classnames('ncss-col-sm-12', { 'ncss-col-md-6': !!cancelAction })}>
          <Button
            type='button'
            extraClassName='ncss-btn-primary-dark mt3-sm mt0-md'
            onClick={confirmAction}
            data-desc='alert__confirm'
            disabled={disabled}
          >
            {confirmText}
          </Button>
        </div>
      </div>
    </div>
  </div>
);

Alert.defaultProps = {
  cancelText: '',
  confirmText: '',
  cancelAction: null,
  confirmAction: null,
  title: '',
  content: '',
  disabled: false
};

Alert.propTypes = {
  cancelText: PropTypes.string,
  cancelAction: PropTypes.func,
  disabled: PropTypes.bool,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  content: PropTypes.any,
  confirmText: PropTypes.string,
  confirmAction: PropTypes.func
};

export default Alert;
